import React from "react";
import styled from "styled-components";

const Btn = styled.a`
	border-radius: 0.5rem;
	padding: ${props => (props.big ? "0.8rem 1.5rem" : "0.25rem 0.5rem")}
	margin:  ${props => (props.big ? "1rem" : "0px")}
	text-decoration: none;
	background: ${props =>
		props.type === "ip"
			? "rgb(255, 200, 90)"
			: props.type === "capacity"
				? "#0097ad"
				: props.type === "colocation"
					? "#96368b"
					: "#24909a"};
	color: #fff;
	pointer-events: all;
	font-size: ${props => (props.big ? "18px" : "14px")}
	opacity: 1;
		font-weight: 700;

	:hover {
		opacity: 0.8;
	 }
}	
`;

const Button = ({ title, href, type, big }) => {
	return (
		<Btn data-ga-cta-service={type.toLowerCase()} href={href} type={type} big={big} target="blank">
			{title}
		</Btn>
	);
};

export default Button;
